module.exports = __webpack_public_path__ + "static/img/babeflirtM.95d0634d.jpg";